export const defaultStyle = {
    TopNavWrapIN:"TopNavWrapIN flex items-center relative",
    TopNavMegaWrap:"TopNavMegaWrap h-[0]  overflow-hidden absolute top-[30px] left-0 min-w-[250px] z-[999] bg-white",
    TopNavLink:"w-full  flex text-[18px] leading-[18px] font-Regular border-b-[1px] border-transparent hover:border-b-[1px] hover:border-[#666] tracking-[1.8px] uppercase relative",
    TopNavBtn:"w-full  flex text-[18px] leading-[18px] font-Regular border-b-[1px] border-transparent hover:border-b-[1px] hover:border-[#666]  tracking-[1.8px] uppercase relative",
    
}